module.exports = __webpack_public_path__ + "img/hayward.5f076f15.png";